import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import "../../styles/marketing.css";
import Seo, { breadcrumbJsonLd, SITE_URL } from "../../components/marketing/Seo";
import MarketingNav from "../../components/marketing/MarketingNav";
import MarketingFooter from "../../components/marketing/MarketingFooter";
import CtaBanner from "../../components/marketing/CtaBanner";
import Reveal from "../../components/marketing/Reveal";
import { INDUSTRIES } from "../../data/industriesData";

export default function IndustriesIndexPage() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "Industries", path: "/industries" },
  ];
  return (
    <div className="mk min-h-screen overflow-x-hidden" data-testid="industries-index-page">
      <Seo
        title="Industries — Field Service Software by Trade | Fieldz AI"
        description="Fieldz AI is built for locksmiths, HVAC, plumbing, electrical, garage door, appliance repair, cleaning, and handyman businesses. See how it fits your trade."
        path="/industries"
        image={`${SITE_URL}/marketing/og/og-industries.jpg`}
        jsonLd={breadcrumbJsonLd(crumbs)}
      />
      <MarketingNav />

      <section className="pt-28 md:pt-36 pb-12 bg-gradient-to-b from-blue-50/70 via-white to-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[var(--mk-blue)] mb-5">Industries</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 leading-[1.1] mb-5">
            Field service software, shaped to your trade
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed">
            The same powerful platform — dispatch, phone, invoicing, payments — applied to the way your industry actually works.
          </p>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.slug} delay={Math.min((i % 4) + 1, 4)}>
                <Link
                  to={`/industries/${ind.slug}`}
                  className="group block h-full rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_16px_32px_-12px_rgba(15,23,42,0.14)] hover:border-blue-200"
                  data-testid={`industries-index-card-${ind.slug}`}
                >
                  <div className="w-11 h-11 rounded-xl bg-[var(--mk-blue-light)] flex items-center justify-center mb-4">
                    <ind.icon className="w-5 h-5 text-[var(--mk-blue)]" />
                  </div>
                  <h2 className="text-[17px] font-semibold text-slate-900 mb-2">{ind.name}</h2>
                  <p className="text-[14px] text-slate-500 leading-relaxed mb-4 line-clamp-3">{ind.intro}</p>
                  <span className="inline-flex items-center gap-1 text-[14px] font-semibold text-[var(--mk-blue)]">
                    See how it fits <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBanner />
      <MarketingFooter />
    </div>
  );
}
